import React, { useEffect, useState } from "react";
import { Menu } from "antd";
const { SubMenu } = Menu;

import { leftMenuToggle } from 'store/actions/home'

import Icon, { PlusOutlined } from "@ant-design/icons";
import { NavLink, useHistory, useLocation } from "react-router-dom";


import { connect } from "react-redux";
import { getPathnameByIndex } from "../../../../services/helper";
import { leftMenus } from "../../../../../root/Routes/Routes";
import { checkAnyPermission, checkPermission } from "../../../../services/permission";
import { getCurrentCompany } from "../../../../services/user";
import { useActions } from '../../../../hooks/useActions'
import useResponsiveWidth from "hooks/useResponsiveWidth";
import {
    AccountIco,
    AcquiringIco,
    BusinessCardIco, CreditIco, DepositsIco,
    HomePageIco,
    NewTransferIco, OrdersPageIco, SalaryIco,
    TransfersIco
} from "../../../../../modules/CustomIcons";
import i18next from "../../../../../i18n";
import { useTranslation } from "react-i18next";
import { useAbility } from "@shared/AccessManager";




/**/

const Menus: React.FC<any> = ({ leftMenuStatus, companyData }) => {
    const history = useHistory();
    const location = useLocation();
    const { leftMenuToggle } = useActions()
    const [rootSubmenuKeys, setRootSubmenuKeys] = useState<any>([]);
    const { t } = useTranslation()
    const ability = useAbility()
    // const menus = leftMenus;
    const responsiveWidth = useResponsiveWidth();
    const menus = [
        {
            title: t("home.main"),
            path: '/',
            icon: HomePageIco,
            subs: [],
            permissionKey: 'ALL'
        },
        {
            title: i18next.t("home.transfers"),
            path: '/transfers/ALL',
            icon: TransfersIco,
            subs: [],
            permissionKeys: ['AZIPS', 'SWIFT', 'XOHKS', 'BATCH_PAYMENT', 'EXCHANGE', 'INTERNAL', 'OWN_ACCOUNT', 'DXA', 'IPS_OTH', 'IPS_BDG', 'IPS_VAT', 'EDV', 'GPP', 'SWIFT_RUB', 'TEMPLATE', 'SALARY_TOTAL']
        },
        {
            title: i18next.t("home.newTransfer"),
            path: '/new_transfer/',
            icon: NewTransferIco,
            permissionKeys: ['OWN_ACCOUNT', 'INTERNAL', 'EXCHANGE', 'AZIPS', 'XOHKS', 'DXA', 'EDV', 'SWIFT', 'SWIFT_RUB', 'GPP', 'TEMPLATE', 'IPS_OTH', 'IPS_BDG', 'IPS_VAT'],
            subs: [
                {
                    title: i18next.t("home.internal"),
                    path: '/new_transfer/inside_bank',
                    permissionKeys: ['OWN_ACCOUNT', 'INTERNAL'],
                    subs: [
                        {
                            title: i18next.t("newTransfer.ownAccount"),
                            path: '/new_transfer/inside_bank/own_account',
                            permissionKey: 'OWN_ACCOUNT',
                        },
                        {
                            title: i18next.t("newTransfer.toOtherAccount"),
                            path: '/new_transfer/inside_bank/other_account',
                            permissionKey: 'INTERNAL',
                        }
                    ]
                },
                {
                    title: i18next.t("home.currencyExchange"),
                    path: '/new_transfer/currency_exchange',
                    subs: [],
                    permissionKey: 'EXCHANGE',
                },
                {
                    title: i18next.t("home.domesticAZN"),
                    path: '/new_transfer/domestic',
                    permissionKeys: ['AZIPS', 'XOHKS', 'DXA', 'EDV'],
                    subs: [
                        {
                            title: 'AZİPS',
                            path: '/new_transfer/domestic/azips',
                            permissionKey: 'AZIPS',
                        },
                        {
                            title: 'XÖHKS',
                            path: '/new_transfer/domestic/hoks',
                            permissionKey: 'XOHKS',
                        },
                        {
                            title: i18next.t("home.budgetSTA"),
                            path: '/new_transfer/domestic/dxa',
                            permissionKey: 'DXA',
                        },
                        {
                            title: i18next.t("home.budgetVAT"),
                            path: '/new_transfer/domestic/edv',
                            permissionKey: 'EDV',
                        }
                    ]
                },
                {
                    title: <div>
                        {/*<div className="oldword" style={{display:"flex"}}>*/}
                        <span >AniPay</span>
                        {/*<div className="newword4" style={{left:102}}>*/}
                        {/*    <span className="newword">new</span></div>*/}
                        {/*</div>*/}
                    </div>,
                    path: '/new_transfer/anipay',
                    permissionKeys: ['IPS_OTH', 'IPS_BDG', 'IPS_VAT'],
                    subs: [
                        {
                            title: t('transfers.anipayNonBudget'),
                            path: '/new_transfer/anipay/qbudce',
                            permissionKey: 'IPS_OTH',
                        },
                        {
                            title: t('transfers.aniPaySTA'),
                            path: '/new_transfer/anipay/dxa',
                            permissionKey: 'IPS_BDG',
                        },
                        {
                            title: t('transfers.aniPayVAT'),
                            path: '/new_transfer/anipay/edv',
                            permissionKey: 'IPS_VAT',
                        },
                    ]
                },
                {
                    title: i18next.t("home.foreignCurrency"),
                    path: '/new_transfer/foreign_currency',
                    permissionKeys: ['SWIFT', 'SWIFT_RUB'],
                    subs: [
                        {
                            title: i18next.t("home.foreignCurrencyTransfer"),
                            path: '/new_transfer/foreign_currency/money_transfer',
                            permissionKey: 'SWIFT',
                        },
                        {
                            title: 'RUB',
                            path: '/new_transfer/foreign_currency/rub',
                            permissionKey: 'SWIFT_RUB',
                        }
                    ]
                },

                {
                    title: <div>
                        {/*<div className="oldword">*/}
                        <span > {i18next.t('transfers.gpp')} </span>
                        {/*<div className="newword4" style={{left:85}}> */}
                        {/*    <span className="hopword">new</span></div>*/}
                        {/*</div>*/}
                    </div>,
                    path: '/new_transfer/gpp',
                    subs: [],
                    permissionKeys: ['GPP'],
                },
                {
                    title: <div>
                        <div className="oldword">
                            <span style={{lineHeight: "40px"}}> {i18next.t('transfers.batchtransferswithoutsource')} </span>
                            <div style={{ display: "inline-block", position: "relative", top: '-10px', right: '2px' }}>
                                <span ></span>
                            </div>
                        </div>
                    </div>,
                    path: '/new_transfer/mass_transfers',
                    subs: [],
                    permissionKeys: ['BATCH_PAYMENT'],
                }
                ,
                {
                    title: i18next.t("home.templates"),
                    path: '/new_transfer/templates',
                    subs: [],
                    permissionKey: 'TEMPLATE',
                }
            ]
        },
        {
            title: i18next.t("home.accounts"),
            path: '/accounts/',
            icon: AccountIco,
            permissionKeys: ['ALL'],
            subs: [
                {
                    title: i18next.t("home.accounts"),
                    path: '/accounts/accounts',
                    permissionKey: 'CARILIST',
                    subs: []
                },
                {
                    title: i18next.t("home.accountStatement"),
                    path: '/accounts/account_statement',
                    permissionKey: 'ALL',
                    subs: []
                }
            ]
        },
        {
            title: i18next.t("home.businessCards"),
            path: '/business_cards/',
            icon: BusinessCardIco,
            permissionKeys: ['ALL'],
            subs: [
                {
                    title:  <>{i18next.t("home.businessCards")} 
                  
                    {/* <div
                      style={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        backgroundColor: '#F3646C',
                        marginLeft: '4px',
                      }}
                    ></div> */}
                    </>,
                    path: '/business_cards/cards',
                    permissionKey: 'CARDLIST',
                    caslModulName: 'BusinessCards',
                    subs: []
                },
                {
                    title: i18next.t("businessCards.cardshortAccountStatement"),
                    path: '/business_cards/card_account_statement',
                    permissionKey: 'EXTRE_CARD_ACC',
                    subs: []
                }, {
                    title: i18next.t("businessCards.cardStatement"),
                    path: '/business_cards/card_accountpan_statement',
                    permissionKey: 'EXTRE_CARD_PIN',
                    subs: []
                }
            ]
        },
        {
            title: i18next.t("home.salary"),
            path: '/salary/',
            icon: SalaryIco,
            permissionKeys: ['SALARY_TOTAL', 'SALARY_EMP','EXTRE_SALARY'],
            subs: [
                {
                    title: i18next.t("home.transfer"),
                    path: '/salary/transfer',
                    permissionKey: 'SALARY_TOTAL',
                    subs: []
                },
                {
                    title: i18next.t("home.listOfEmployees"),
                    path: '/salary/list',
                    permissionKey: 'SALARY_EMP',
                    subs: []
                },
                {
                    title: i18next.t("home.statement"),
                    path: '/salary/print',
                    permissionKey: 'EXTRE_SALARY',
                    subs: []
                }
            ]
        },
        {
            title: i18next.t("home.loans"),
            path: '/credits',
            icon: CreditIco,
            permissionKey: 'CREDITLIST',
            subs: []
        },
        {
            title: i18next.t("home.deposits"),
            path: '/deposits',
            icon: DepositsIco,
            permissionKey: 'DEPOSITLIST',
            subs: []
        },
        {
            title: i18next.t("home.acquiring"),
            path: '/acquiring/',
            caslModulName: 'Acquiring',
            icon: AcquiringIco,
            permissionKeys: ['ALL'],
            subs: [
                {
                    title: i18next.t("home.posreport"),
                    path: '/acquiring/posreport',
                    permissionKey: 'ALL',
                    subs: []
                },
            ]
        },
        {
            title: <div>
                <div className="oldword">
                    <span style={{lineHeight: "40px"}}> {i18next.t("home.orders")} </span>
                    <div style={{ display: "inline-block", position: "relative", top: '-10px', right: '2px' }}>
                        <span className="hopword">new</span>
                    </div>
                </div>
            </div>,
            path: '/orders/',
            icon: OrdersPageIco,
            viewable: ability.can('view', 'OrderMenuItem'),
            permissionKeys: ['ALL'],
            subs: [
                {
                    title: i18next.t("home.salaryCard"),
                    path: '/orders/salary-card',
                    caslModulName: 'SalaryCard',
                    permissionKeys: ['ALL'],
                    viewable: ability.can('view', 'SalaryCardMenuItem'),
                    subs: []
                },
                {
                    title: i18next.t("businessCardOrders.businessCards"),
                    path: '/orders/business-card',
                    caslModulName: 'BusinessCardOrderCard',
                    permissionKeys: ['ALL'],
                    viewable: ability.can('view', 'BusinessCardOrderMenuItem'),
                    subs: []
                }
            ]
        },
    ]
    let array = [
        '/' + getPathnameByIndex(0) + '/',
        '/' + getPathnameByIndex(0) + '/' + getPathnameByIndex(1),
        '/' + getPathnameByIndex(0) + '/' + getPathnameByIndex(1) + '/' + getPathnameByIndex(2),
    ]

    const [openKeys, setOpenKeys] = useState<any>(array);

    useEffect(() => {

        menus.map((row, index1) => {
            setRootSubmenuKeys(old_keys => [...old_keys, row.path]);

        });

        let array = [
            '/' + getPathnameByIndex(0) + '/',
            '/' + getPathnameByIndex(0) + '/' + getPathnameByIndex(1),
            '/' + getPathnameByIndex(0) + '/' + getPathnameByIndex(1) + '/' + getPathnameByIndex(2),
        ]

        setOpenKeys(old_data => array);

    }, [location, companyData]);

    const onOpenChange = keys => {
        const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);

        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }


    };

    const onClick = (item, key, keyPath, domEvent) => {
        if (responsiveWidth <= 992) {
            leftMenuToggle(true)
        }
        history.push(item.key);

    }

    const onTitleClick = (item, key, domEvent) => {
        if (!location.pathname.includes(item.key)) {
            history.push(item.key);

        } else {

            //history.push(`${item.key}`);
        }

    }

    return (

        <Menu
            mode="inline"
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            onClick={onClick}
            multiple={false}
            // onSelect={onSelect}
            // onDeselect={onSelect}
            selectable={false}
            className={'left_main_menus'}
        >
            {
                menus.map((row, index1) => {
                    let menu_1_active_class = location.pathname == row.path ? 'left_menu_active_1' : '';
                    const isShow = row.viewable === false ? false : true

                    return (
                        <>
                            {

                                isShow && row.subs.length > 0 && !leftMenuStatus && checkAnyPermission(row.permissionKeys) ?
                                    <SubMenu
                                        index={row.path}
                                        key={row.path}
                                        title={row.title}
                                        icon={<Icon component={() => (<row.icon />)} />}
                                        onTitleClick={onTitleClick}
                                        className={menu_1_active_class}
                                    >
                                        {
                                            row.subs.map((sub_menu, index2) => {
                                                const isShow = sub_menu?.viewable === false ? false : true

                                                const newLocation = location.pathname.split("/").length - 1 === 3 ? location.pathname.substring(0, location.pathname.lastIndexOf('/')) : location.pathname;

                                                let menu_2_active_class = newLocation == sub_menu.path ? 'left_menu_active_2' : '';

                                                return (
                                                    <>
                                                        {
                                                            isShow && sub_menu.subs.length > 0 && checkAnyPermission(sub_menu.permissionKeys) ?
                                                                <SubMenu
                                                                    key={sub_menu.path}
                                                                    title={sub_menu.title}
                                                                    onTitleClick={onTitleClick}
                                                                    className={menu_2_active_class}
                                                                >
                                                                    {
                                                                        sub_menu.subs.map((sub_menu2, index3) => {
                                                                            let menu_3_active_class = location.pathname == sub_menu2.path ? 'left_menu_active_3' : '';
                                                                            return checkPermission(sub_menu2.permissionKey) && (
                                                                                <Menu.Item className={menu_3_active_class} key={sub_menu2.path} >
                                                                                    <NavLink activeClassName={'active'} exact={true} to={sub_menu2.path} >{sub_menu2.title}</NavLink>
                                                                                </Menu.Item>
                                                                            )
                                                                        })
                                                                    }
                                                                </SubMenu>
                                                                : (isShow && (sub_menu.permissionKey ? checkPermission(sub_menu.permissionKey) : checkAnyPermission(sub_menu.permissionKeys))) && <Menu.Item className={menu_2_active_class} key={sub_menu.path} >
                                                                    <NavLink activeClassName={'active'} exact={true} to={sub_menu.path} >{sub_menu.title}</NavLink>
                                                                </Menu.Item>
                                                        }
                                                    </>
                                                )
                                            })
                                        }
                                    </SubMenu>

                                    : (row.permissionKey ? isShow && checkPermission(row.permissionKey) : isShow && checkAnyPermission(row.permissionKeys)) && <Menu.Item className={menu_1_active_class} key={row.path} title={row.title} icon={<Icon component={() => (<row.icon />)} />} >
                                        <NavLink activeClassName={'active'} exact={true} to={row.path}>{row.title}</NavLink>
                                    </Menu.Item>
                            }
                        </>
                    )
                })
            }
        </Menu>
    )
}

const mapDispatchToProps = { leftMenuToggle }

const mapStateToProps = (state: any) => ({
    leftMenuStatus: state.home.leftMenuStatus,
    companyData: (state.user && state.user.companyData.result) ? state.user.companyData.result.customerNo : getCurrentCompany()
})

export default connect(mapStateToProps, mapDispatchToProps)(Menus)
